var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.profilePic)?_c('img',{staticStyle:{"border-radius":"4px"},attrs:{"src":_vm.profilePic,"height":"33","width":"33"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }